<template lang="pug">
section.LndAbout.d-flex.--col
  .d-flex.__head(:class="mq.sm && '--col'")
    h2(v-html="header")
    //- hr.d-not-sm
    //- .d-flex.__achvs
      template(v-for="item of achs.list")
        img(v-if="item.img", :srcset="`${ item.img } 1.5x`", :alt="item.txt")
        Svgi(v-else-if="item.$svg", :name="item.$svg")


  .d-flex.__grid.__contents(:class="mq.sm && '--col'")
    div(v-for="({ header, contents }, i) of list")
      h3.d-flex.--middle
        Svgi.__icon(:name="`about-${ i+1 }`")
        span(v-html="header")

      template(v-for="textOrList of contents")
        template(v-if="isArr(textOrList)")
          ul.ul-disk
            li(v-for="li of textOrList", v-html="li")
        p(v-else, v-html="textOrList")

</template>
<script>
import content from 'content';

export default {
  name: 'LndAbout',
  inject: ['mq'],

  static: () => ({
    ...content.about,
    achs: content.achs,
  }),
};

</script>
<style>
.LndAbout {
  --gap-v: 54px;

  h3 {
    --gap-h: 25px;

    font-size: 20px;

    margin-bottom: 40px;
  }

  li,
  p {
    line-height: 30px;
  }

  .__contents > div > * {
    p:not(:last-child) { margin-bottom: 1.5em; }
    > li:not(:last-child) { margin-bottom: 1.5em; }
  }

  .__icon {
    width: 50px;
    height: 50px;
  }
}

@media (min-width: 740px) {
  .LndAbout {
    .__head {
      --gap-h: 30px;
      align-items: center;
      height: 70px;
      margin-bottom: 32px;

      hr {
        height: 100%;

        border-left: 1px solid var(--sep-c);
      }

    }
    .__achvs {
      --gap-h: 46px;

      > * { height: 22px }

      [data-name="soc-fb"] {
        width: 22px;

        filter: invert(1);
      }
    }

    .__grid {
      --gap-h: 20px;

      > * {
        flex-basis: 50%;
        flex-shrink: 2;
        flex-grow: 2;
        padding: 30px;

        background: var(--bg-dark-c);
      }
    }

    /*.__achvs {
      width: 66%;
      flex-basis: unset;
      padding-right: 15%;


      li {
        display: inline-block;

        white-space: nowrap;
      }
    }*/
  }
}

@media (max-width: 739px) {
  .LndAbout {
    h2 { margin-bottom: 60px; }
    .__contents {
      --gap-v: 64px;
    }

    .__head {
      align-items: stretch;
      margin-bottom: 80px;
    }

    .__achvs {
      justify-content: space-between;

      > * { height: 26px }

      [data-name="soc-fb"] {
        width: 18px;

        filter: invert(1);
      }
    }
  }
}
</style>
